import ConfirmModal from 'views/components/ConfirmModal'

import useRemoveGroupHandler from '../../../effects/remove-group'
import { Group } from '../../../../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type RemoveGroupModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	group: Group,
}

export default function RemoveGroupModal( { onCancel, onSuccess, group }: RemoveGroupModalProps ) {
	const removeGroup = useRemoveGroupHandler()

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Remove Group Modal - Click - Remove', {} )
		return await removeGroup( group )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Remove Group Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ConfirmModal
			message={`You are about to remove ${group.name}. Do you want to proceed?`}
			onConfirm={async() => await handleSubmit()}
			buttonColor="danger"
			buttonText="Remove"
			onCancel={handleCancel}
			onSuccess={onSuccess}
		/>
	)
}
